/* eslint-disable import/no-cycle */
/* eslint-disable no-console */
/* eslint-disable no-void */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/extensions */
/* eslint-disable @typescript-eslint/no-misused-promises */
import { get } from 'svelte/store';
import { getMessaging, getToken, onMessage, type Messaging, isSupported } from 'firebase/messaging';
import { getAuth } from 'firebase/auth';
import { initializeApp } from 'firebase/app';

import {
    firebaseAuthStore,
    firebaseMessaging,
    firebaseMessagingToken,
    firebaseStore
} from '../stores/firebase.store';


// FIXME: https://i.imgur.com/qx7jm0U.png 
// Idk how to resolve this circular dependency
import { getMe, saveFcmToken } from './api/user.util';


import { handleFcmNotification } from './fcm.util';
import { me } from '$src/stores/user.store';
import { goto } from '$app/navigation';
import { authStatus } from '$src/stores/auth.store';
import { PUBLIC_VAPID_KEY } from '$env/static/public';

// Define a new function to handle messaging
async function handleMessaging(user, messaging: Messaging) {
    if (user && messaging) {
        try {
            const currentToken = await getToken(messaging, {
                vapidKey: PUBLIC_VAPID_KEY
            });
            if (currentToken) {
                await saveFcmToken(currentToken);
                firebaseMessagingToken.set(currentToken);
                onMessage(get(firebaseMessaging), payload => {
                    void handleFcmNotification(payload.data);
                });
            } else {
                // Show permission request UI
                console.log('No registration token available. Request permission to generate one.');
            }

        } catch (error) {
            await getMe();
            console.log('Notification permissions blocked by user.');
        }
    }
}


export const initilizeFirebase = async () => {
    try {

        let firebaseConfig: unknown;

        if (import.meta.env.VITE_DEPLOYMENT !== 'production') {
            firebaseConfig = {
                apiKey: 'AIzaSyCHGzw6idPxmsPTH9OK0QUAux3j7UnxzDQ',
                authDomain: 'the-garden-dev.firebaseapp.com',
                projectId: 'the-garden-dev',
                storageBucket: 'the-garden-dev.appspot.com',
                messagingSenderId: '716019832047',
                appId: '1:716019832047:web:7e1b7fd131d8206f97f71a'
            };
        } else {
            firebaseConfig = {
                apiKey: 'AIzaSyCTAPNdZYOr0NT-bGUsW1BtElaalXym7O0',
                authDomain: 'the-garden-prod.firebaseapp.com',
                projectId: 'the-garden-prod',
                storageBucket: 'the-garden-prod.appspot.com',
                messagingSenderId: '1095521206307',
                appId: '1:1095521206307:web:c64b4af98584fdc16b3196'
            };
        }

        const app = initializeApp(firebaseConfig);
        const auth = getAuth();
        let messaging: Messaging | null = null;

        if (await isSupported()) {
            messaging = getMessaging(app);
            firebaseMessaging.set(messaging);
        }

        firebaseStore.set(app);

        auth.onAuthStateChanged(async user => {
            firebaseAuthStore.set({
                user,
                loading: false
            });

            if (get(me) && !get(me).emailVerified) {
                authStatus.set('verify');
                void goto('/sign-up');
            }

            // Delete normal user if exists
            if (!user && get(me)?.firebaseuid) {
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
            }
            await getMe();
            // Call the new function
            await handleMessaging(user, messaging);
        });
    } catch (error) {
        console.error(error);
    }
};
